export enum TextRoutesEnum{
    SEND_TEXT = 'send-text',

    SENT_TEXTS = 'sent-texts'
}